export type TestIDSet = {
  testId: string
  selector: string
}

/**
 * Given a string, returns a TestID Set - an object that contains
 * the `data-test-id` value for an element and a selector that targets that element.
 *
 * @param testId - unique identifier for the targeted element. Should be set to the `data-test-id`attribute.
 * @returns A TestID Set object (contains the testId and a selector for the element)
 */
export const createTestId = (testId: string): TestIDSet => ({
  testId,
  selector: `[data-test-id="${testId}"]`,
})
